
function AdventChild() {
  return (<div className="container">
    <h2>Standards de sécurité des enfants – <span className="App-title">Calendrier de l'Advent</span></h2>

    <p>Last updated:  Octobre 10th, 2026</p>
    <h3>Notre position</h3>
    <p>
      <span className="App-title">Calendrier de l'Advent</span> est un calendrier de l'avent privé : un utilisateur invite des proches (famille, amis) à remplir les cases de son calendrier. Il n'existe aucun contenu public, aucun fil d'actualité et aucune fonction de recherche de profils ou de rencontre entre inconnus    </p>
    <p>Nous appliquons une tolérance zéro envers toute forme d'abus ou d'exploitation sexuelle des enfants (CSAE, child sexual abuse and exploitation) et toute tentative d'utiliser l'application à cette fin.</p>

    <h3>Contenus et comportements interdits</h3>
    <p>Il est strictement interdit de publier, d'envoyer ou de partager via l'application :
      <ul>
        <li>tout contenu à caractère sexuel impliquant un mineur ;</li>
        <li>tout contenu sexualisant des enfants, y compris textes, images, vidéos ou audio ;</li>
        <li>toute sollicitation, manipulation ou approche d'un mineur à des fins sexuelles (grooming) ;</li>
        <li>tout contenu encourageant ou facilitant l'exploitation d'un enfant.</li>
      </ul>
    </p>

    <h3>Prévention</h3>
    <p>
      <ul>
        <li><b>Espace privé :</b> un calendrier n'est accessible qu'aux personnes que son propriétaire a invitées. Rien n'est visible publiquement.</li>
        <li><b>Pas de contact avec des inconnus :</b>  les utilisateurs ne peuvent pas rechercher d'autres utilisateurs ni les contacter sans invitation.</li>
        <li><b>Contrôle total :</b> chaque utilisateur peut à tout moment mettre fin à la relation avec un contributeur ou un destinataire et le retirer de son calendrier.</li>
      </ul>
    </p>
    <h3>Signalement</h3>
    <p>Pour signaler un contenu, un comportement ou un compte préoccupant, écrivez à tryciaspas@gmail.com. Indiquez, si possible, le calendrier ou le compte concerné et une description de la situation. Les signalements concernant la sécurité des enfants sont traités en priorité.</p>
    <h3>Ce que nous faisons en cas de signalement</h3>
    <p>
      <ul>
        <li>Le contenu concerné est supprimé dès sa détection ou son signalement.</li>
        <li>Le ou les comptes impliqués sont suspendus ou supprimés définitivement.</li>
        <li>Les contenus illégaux impliquant des mineurs sont signalés aux autorités compétentes (en France, via la plateforme Pharos ; à l'international, au NCMEC), et nous coopérons avec les enquêtes dans le cadre de la loi</li>
      </ul>
    </p>
    <h3>Contact</h3>
    <p> Responsable de la sécurité des enfants :équipe Calendrier de l'Advent</p>
    <p>Responsable de la sécurité des enfants :
      E-mail : tryciaspas at gmail dot com.</p>

  </div>);
}
export default AdventChild;
